import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from './cn';

/**
 * Select — Design System v2 (docs/design-system-v2.html §5.select).
 *
 * Mesmo visual do {@link Input}, com chevron via background-image (sem
 * dependência de @tailwindcss/forms). `appearance:none` cuida do native UI.
 */

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

const CHEVRON_SVG =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")";

// Mesma altura do {@link Input} (44px) para alinhar com docs/design/login_mockup.html.
const BASE =
  'w-full h-11 rounded-md border border-border-strong bg-bg-surface-v2 pl-[14px] pr-[38px] font-body text-[14px] text-text-primary transition-all focus:outline-none focus:border-primary focus:shadow-ring disabled:opacity-60 disabled:cursor-not-allowed appearance-none bg-no-repeat';

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, style, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn(BASE, className)}
      style={{
        backgroundImage: CHEVRON_SVG,
        backgroundPosition: 'right 13px center',
        ...style,
      }}
      {...rest}
    >
      {children}
    </select>
  );
});
